module.exports = __webpack_public_path__ + "static/img/2_1_3_2.47944312.jpg";